<template>
  <div>
    <div class="searchNavBar flex flex_start">
      <div class="title">惠拼优选</div>
      <van-search placeholder="请输入搜索关键词" shape="round" :background="m_color" style="width: 100%"
                  @click="$router.push('/common/search?active=3')">
      </van-search>
    </div>
    <div class="tabBox">
      <van-tabs :active="tabIndex" background="#E61B1B" color="#ffffff" title-active-color="#ffffff"
                title-inactive-color="#ffffff" :border="false" :ellipsis="false" @click="changeTab">
        <van-tab title="我惠推送"></van-tab>
        <van-tab title="实时热销榜"></van-tab>
        <van-tab title="实时收益榜"></van-tab>
        <van-tab title="今日销量榜"></van-tab>
      </van-tabs>
    </div>
    <!--占绝对定位的高度-->
    <div style="height: 100px;"></div>
    <!--排序Bar-->
    <sortBar :sortType="sortType" @bindSort="changeSort"></sortBar>
    <mescroll-vue class="mescroll" :class="{'mescroll1':isIos}" ref="mescroll" :down="mescrollDown" :up="mescrollUp"
                  @init="mescrollInit">
      <div class="list" id="listId">
        <div v-for="(item, i) in dataList" :key="i" class="white">
          <goodsItem :item="item" layoutType="0" source="PDD">
          </goodsItem>
        </div>
      </div>
    </mescroll-vue>
    <!--底部菜单-->
    <foot-bar :active="3"></foot-bar>
  </div>
</template>

<script>
import {pddRecommend, pddWHPush} from "../../../api/commonV2";

export default {
  name: 'hpyx',
  data() {
    return {
      uid: '',//会员id
      tabIndex: 0,
      dataList: [],
      type: '',
      listId: '',
      sortType: 0, //排序
    }
  },
  created() {
    this.uid = localStorage.getItem("uid") || ''
    if (!this.uid) {
      this.$router.push('/user/login')
    }
  },
  methods: {
    // 切换排序规则
    changeSort(val) {
      switch (val) {
        case 0:
          this.sortType = 0
          break
        case 1:
          this.sortType === 1 ? this.sortType = 2 : this.sortType = 1
          break
        case 2:
          this.sortType === 3 ? this.sortType = 4 : this.sortType = 3
          break
        case 3:
          this.sortType === 5 ? this.sortType = 6 : this.sortType = 5
          break
      }
      this.$nextTick(
        function () {
          this.mescroll.resetUpScroll()
        }
      )
    },
    changeTab(index) {
      console.log(this.tabIndex)
      this.tabIndex = index
      if (this.tabIndex === 1) {
        this.type = 5
      } else if (this.tabIndex === 2) {
        this.type = 6
      } else if (this.tabIndex === 3) {
        this.type = 1
      }
      this.dataList = []
      this.mescroll.resetUpScroll(false)
    },
    // 上拉加载
    upCallback(val) {
      let data = {
        uid: this.uid,
        pageNo: val.num,
        pageSize: val.size,
        type: this.type,
        sortType: this.sortType,
        listId: this.listId
      }
      if (val.num === 1) {
        this.dataList = []
      }
      if (this.tabIndex != 0) {
        pddRecommend(data).then(res => {
          if (res.result == '0') {
            if (res.author === '1') {
              this.listId = res.listId
              res.dataList ? this.dataList = this.dataList.concat(res.dataList) : ''
              this.mescroll.endByPage(res.dataList ? res.dataList.length : 0, res.totalPage)
            } else {
              //去授权
              //  window.location.href=res.mobile_url;
              this.$router.push('/union/pdd/pddOauth?backUrl=' + encodeURIComponent(this.$route.path))
            }
          }
        }, err => {
          this.mescroll.endErr()
        })
      } else {
        pddWHPush(data).then(res => {
          if (res.result == '0') {
            if (res.author === '1') {
              this.listId = res.listId
              res.dataList ? this.dataList = this.dataList.concat(res.dataList) : ''
              this.mescroll.endByPage(res.dataList ? res.dataList.length : 0, res.totalPage)
            } else {
              //去授权
              // window.location.href=res.mobile_url;
              this.$router.push('/union/pdd/pddOauth?backUrl=' + encodeURIComponent(this.$route.path))
            }
          } else if (res.result == '0' && res.mobile_url.length > 0) {

          }
        }, err => {
          // alert('err')
          this.mescroll.endErr()
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.tabBox {
  position: fixed;
  top: 50px;
  z-index: 99;
  width: 100%;
}

/deep/ .van-tabs__scroll {
  background-color: #E61B1B;
}
</style>



// WEBPACK FOOTER //
// src/view/tabBar/hpyx/index.vue